module.exports = __webpack_public_path__ + "img/afa-light.022a2ec8.png";